import React from 'react';

import CSSModules from 'react-css-modules';
import AutoSizer from 'react-virtualized-auto-sizer';
import {FixedSizeGrid as Grid} from 'react-window';

import Cell from './Cell';

import styles from './styles.module.scss';

interface MediaGridComponentProps {
  content: React.ReactNode[];
}
const MediaGridComponent = ({content}: MediaGridComponentProps) => (
  <AutoSizer defaultWidth={498} defaultHeight={537}>
    {({width, height}) => {
      const columnCount = width > 480 ? 2 : 1;
      const rowCount = Math.ceil(content.length / columnCount);
      const cellWidth = width / columnCount;
      const cellHeight = 179;

      return (
        <Grid
          className={styles['grid']}
          width={width + 40}
          height={height}
          columnCount={columnCount}
          columnWidth={cellWidth}
          rowCount={rowCount}
          rowHeight={cellHeight}
          itemData={{content, columnCount}}
        >
          {Cell}
        </Grid>
      );
    }}
  </AutoSizer>
);

export const MediaGrid = CSSModules(MediaGridComponent, styles);
